import { Chart } from "react-google-charts";
import { FONTS, PRIMARY_COLOR, SECONDARY_COLOR } from "../../constants";

export function Scatter({
  data,
  ticks,
  minX,
  maxX,
  minY,
  maxY,
  yTitle,
  xTitle,
  trendlines = true,
  height = "380px",
}) {
  let tl = trendlines
    ? {
        0: {
          type: "linear",
          color: PRIMARY_COLOR,
          lineWidth: 5,
          opacity: 0.7,
          tooltip: false,
        },
      }
    : {};

  let tmp = (
    <Chart
      style={{
        height: height,
        width: "100%",
      }}
      chartType="ScatterChart"
      loader={<div>Loading Chart</div>}
      data={data}
      options={{
        // Material design options
        legend: { position: "none" },
        colors: [SECONDARY_COLOR],
        trendlines: tl,
        chartArea: {
          width: "90%",
          height: "100%",
          top: 10,
          bottom: 60,
          left: 50,
        },
        vAxis: {
          minorGridlines: { color: "white" },
          gridlines: { color: "rgb(220,220,220)" },
          baselineColor: "rgb(220,220,220)",
          textStyle: { fontName: FONTS },
          title: yTitle,
          viewWindow: {
            max: maxY,
            min: minY,
          },
        },
        hAxis: {
          viewWindowMode: "explicit",
          title: xTitle,
          titleTextStyle: { fontName: FONTS },
          ticks: ticks,
          minorGridlines: { color: "white" },
          baselineColor: "rgb(220,220,220)",
          gridlines: { color: "rgb(220,220,220)" },
          textStyle: { fontName: FONTS },
          viewWindow: {
            max: maxX,
            min: minX,
          },
        },
      }}
    />
  );
  return tmp;
}
